import { render } from "./BaseSpinner.vue?vue&type=template&id=d9f709e0"
const script = {}
script.render = render

export default script